import React from "react";
import { CheckCircleOutlined } from "@ant-design/icons";

const CheckItem = (props) => {
  const { text } = props;

  return text ? <CheckCircleOutlined /> : null;
};

export default CheckItem;
